<template>
    <div class="row">
        <div class="col-12 col-lg-4 order-lg-2">
            <account-sidebar
                :lng="lng"
                :mainlng="mainlng"
                :translations="translations"
                :accountlink="accountlink"
                :logoutlink="logoutlink"
                :isaccountroute="false"
                :account="account"
                :refillaccountlink="refillaccountlink"
            ></account-sidebar>
        </div>
        <view-order-container
            :lng="lng"
            :mainlng="mainlng"
            :translations="translations"
            :orders="account.parcels"
            :parcel="parcel"
            ordertype="arrived"
            :paymentmethods="paymentmethods"
            :deliverymethods="deliverymethods"
            :account="account"
            :locations="locations"
            :savedeliverylink="savedeliverylink"
            :dopaymentlink="dopaymentlink"
            :neworderslink="neworderslink"
            :ordersonwarehoselink="ordersonwarehoselink"
            :sentorderslink="sentorderslink"
            :arrivedorderslink="arrivedorderslink"
            :deliveredorderslink="deliveredorderslink"
            :upload_files_link="upload_files_link"
            :delete_files_link="delete_files_link"
            :downloadlink="downloadlink"
            :refusebillLink="refusebilllink"
            :confirmorderlink="confirmorderlink"
            :presavedeliverylink="presavedeliverylink"
            :novaposhtacitysearchlink="novaposhtacitysearchlink"
            :novaposhtastreetsearchlink="novaposhtastreetsearchlink"
            :novaposhtawarehousessearchlink="novaposhtawarehousessearchlink"
        ></view-order-container>
    </div>
</template>

<script>
export default {
    name: "ArrivedOrderPage",
    props: {
        account: {
            type: [Object]
        },
        translations: {
            type: [Object, Array]
        },
        lng: {
            type: [String]
        },
        mainlng: {
            type: [String]
        },
        locations: {
            type: [Object, Array]
        },
        isaccountroute: {
            type: [Boolean],
            default: false
        },
        accountlink: {
            type: [String]
        },
        savedeliverylink: {
            type: [String]
        },
        dopaymentlink: {
            type: [String]
        },
        logoutlink: {
            type: [String]
        },
        orders: {
            type: [Object, Array],
            default: () => []
        },
        paymentmethods: {
            type: [Object, Array],
            default: []
        },
        parcel: {
            type: [Object],
            default: null
        },
        ordertype: {
            required: true,
            type: [String]
        },
        deliverymethods: {
            type: [Object, Array],
            default: () => []
        },
        neworderslink: {
            type: [String]
        },
        ordersonwarehoselink: {
            type: [String]
        },
        sentorderslink: {
            type: [String]
        },
        arrivedorderslink: {
            type: [String]
        },
        deliveredorderslink: {
            type: [String]
        },
        refillaccountlink: {
            type: [String]
        },
        setnotificationlink: {
            type: [String]
        },
        upload_files_link: {
            type: [String]
        },
        delete_files_link: {
            type: [String],
            default: null
        },
        downloadlink: {
            type: [String],
            default: null
        },
        refusebilllink: {
            type: [String, Array],
            default: null
        },
        confirmorderlink: {
            type: [String, Array],
            default: null
        },
        presavedeliverylink: {
            type: [String]
        },
        novaposhtacitysearchlink: {
            type: [String]
        },
        novaposhtastreetsearchlink: {
            type: [String]
        },
        novaposhtawarehousessearchlink: {
            type: [String]
        }
    },
    methods: {
        get_translation_constant(key) {
            return this.translations.filter((item) => {
                return item.key === key
            })[0]['value'][this.lng]
        },
    },
    mounted() {

    }
}
</script>

<style scoped>

</style>
